/**
 * Browser Support Check
 *
 * Entry point for browser compatibility checking.
 * Shows a warning banner for users with outdated browsers.
 */

import * as Sentry from '@sentry/browser'
import { isDismissed, showBanner } from './banner'
import { checkBrowser } from './detection'

/**
 * Initialize browser support check.
 * Call early in app initialization, after DOM is ready.
 * Runs asynchronously to avoid blocking page load.
 */
export const initBrowserSupportCheck = (): void => {
  // Run async check without blocking - fire and forget
  checkBrowser()
    .then((result) => {
      if (result.status === 'outdated' && !isDismissed()) {
        showBanner()
      }
    })
    .catch((error) => {
      // Silent fail - browser detection is non-critical
      if (process.env.NODE_ENV === 'production') {
        Sentry.captureException(error, {
          tags: { feature: 'browser-support-check' },
          level: 'warning'
        })
      }
    })
}
